import { render } from "./company-settings.vue?vue&type=template&id=58bc1185&scoped=true"
import script from "./company-settings.vue?vue&type=script&lang=js"
export * from "./company-settings.vue?vue&type=script&lang=js"

import "./company-settings.vue?vue&type=style&index=0&id=58bc1185&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58bc1185"]])

export default __exports__